module.exports = __webpack_public_path__ + "static/media/ac2.77ffc946.jpg";